letterAdjust.scale = .95;
letterAdjust.x = 4;

var font = {"A":"M374.2-59.4L322-395.3l-315.5,0l338.2,1797.6h372.2l338.3-1797.6l-315.5,0L687.3-59.4L374.2-59.4zM530.7,952.9l-118-762.6l236.1,0L530.7,952.9z","B":"M6.5,1402.3h746.8l188.4-163.4V680.5L762.3,551.1L941.6,424v-656L753.2-395.3l-746.8,0V1402.3zM664.7,1154.9l-381.3,0v-488h381.3V1154.9zM664.7-145.7v565.2l-381.3,0v-565.2L664.7-145.7z","C":"M941.6,1238.9V882.5l-276.9,0v272.4l-381.3,0V-145.7l381.3,0v465.3l276.9,0v-551.5L750.9-395.3l-553.9,0L6.5-231.9v1470.8l190.6,163.4h553.9L941.6,1238.9z","D":"M6.5,1402.3h783l188.4-163.4V-231.9L789.5-395.3l-783,0V1402.3zM703.3-145.7v1300.6l-419.9,0V-145.7L703.3-145.7z","E":"M6.5,1402.3h692.3v-247.4l-415.4,0V753.2l274.6,0V503.5l-274.6,0v-649.2l419.9,0v-249.7l-696.8,0V1402.3z","F":"M283.3-395.3l-276.9,0v1797.6l692.3,0v-247.4H283.3v-404h247.4V503.5l-247.4,0V-395.3z","G":"M939.3,1238.9V855.3H664.7v299.6l-381.4,0V-145.7l381.4,0v485.7H558v215.6l494.8,0V340.1H939.3v-572L751-395.3l-553.9,0L6.5-231.9v1470.8l188.4,163.4H751L939.3,1238.9z","H":"M6.5,1402.3l276.9,0V823.5l342.8,0v578.8h274.6V-395.3l-274.6,0v969.2l-342.8,0v-969.2l-276.9,0V1402.3z","I":"M6.5,1402.3h276.9V-395.3l-276.9,0V1402.3z","J":"M664.7,1402.3l276.9,0V-231.9L753.2-395.3l-556.1,0L6.5-231.9v710.4l276.9,0v-624.2l381.4,0V1402.3z","K":"M6.5,1402.3l276.9,0V744.1l385.9,658.2h286l-370-635.5L980.2-395.3l-308.7,0L406,462.6L283.4,256.1v-651.4l-276.9,0V1402.3z","L":"M6.5,1402.3h276.9v-1548l494.7,0v-249.7l-771.7,0V1402.3z","M":"M6.5,1402.3l463,0L608,664.6l145.3,737.7h463V-395.3l-274.6,0V814.4L687.4-395.3l-152.1,0L283.3,794V-395.3l-276.9,0V1402.3z","N":"M6.5,1402.3l286,0l329.1-876.1v876.1h276.9V-395.3l-242.9,0L283.4,569.3v-964.6l-276.9,0V1402.3z","O":"M939.6,1235.4V-232.2L749.3-395.3l-552.6,0L6.5-232.2v1467.6l190.2,163.1h552.6L939.6,1235.4zM282.8,1151.6V-146.1l380.5,0v1297.7H282.8z","P":"M6.5-395.3v1793.8l742.9,0l190.2-163.1V537.8l-188-163.1l-468.9,0v-770.1L6.5-395.3zM663.3,1151.6l-380.5,0V623.9l380.5,0V1151.6z","Q":"M939.5,1484.5V16.8L747.1-146.2l165.3,0v-249.1l-520.9,0v249.1l-197,0L6.5,16.8v1467.6l190.2,165.4h552.6L939.5,1484.5zM282.8,1400.7V102.9l380.5,0v1297.7H282.8z","R":"M6.5-395.3v1793.8l742.9,0l190.3-163.1V467.6L769.7,304.6l185.7-699.9l-342,0l-154,699.9l-176.7,0v-699.9L6.5-395.3zM663.3,1151.6H282.8V553.7l380.5,0V1151.6z","S":"M282.8,204.9v-351l328.4,0v620.5l-414.5,0L6.5,642v593.3l190.2,163.1h502.8l185.7-163.1V920.6H608.9v231H282.8v-428l414.5,0l188-165.3v-790.5l-188-163.1l-500.5,0L6.5-232.2v437.1L282.8,204.9z","T":"M285.1,1151.6H6.5v246.9l844.8,0v-246.9l-289.9,0V-395.3l-276.3,0V1151.6z","U":"M663.3,1398.5l274.1,0V-232.2l-188-163.1l-552.7,0L6.5-232.2v1630.7h276.3V-146.1l380.5,0V1398.5z","V":"M6.5,1398.5h296.7l154-1411l160.8,1411l287.6,0l-231-1793.8l-432.5,0L6.5,1398.5z","W":"M629.3,1398.5H695l124.6-896.9l151.8,896.9h278.6L964.5-395.3l-212.9,0l-122.3,795L507-395.3l-212.9,0L6.5,1398.5l280.9,0l149.4-896.9l126.8,896.9H629.3z","X":"M586.3,1398.5l294.5,0L633.9,544.6l292.1-940l-314.8,0L466.3,186.8l-145-582.1l-314.8,0l292.2,940L51.8,1398.5h294.5l120-516.4L586.3,1398.5z","Y":"M636.1-395.3l-278.5,0v607L6.5,1398.5h301.2l190.3-733.8l194.8,733.8h296.7L636.1,211.7V-395.3z","Z":"M6.5-125.7l473.4,1277.3l-457.5,0v246.9l774.6,0v-283.1L321.3-146.1l466.5,0v-249.2l-781.3,0V-125.7z","h":"M6.5,8l242,0v-262.8l-80.6-140.6H73.3l46.1,140.6l-112.9,0V8z","h":"M665.6-107.2v-288.1l-659.2,0v288.1L665.6-107.2z","2":"M351.5,478.9V-50.2l516.5,0v204.5l345,0v-549.7l-1206.6,0v966.4l265.8,263.4l595.8,0v470.4l-516.5,0v-209.7H9v288.8l263.3,265.9l677.5,0l263.3-265.9V744.8L949.8,478.9L351.5,478.9z","3":"M868-50.2v531.8l-391.1,0v352.9H868v470.4l-516.5,0v-209.7H6.5v288.8l265.8,265.9l675,0l265.8-265.9V765.4l-25.5-30.8l-81.9-92l94.7-99.7l2.5-2.7l10.2-10.2v-659.5L949.8-395.3l-677.5,0L6.5-129.4v283.8l345,0V-50.2L868-50.2z","1":"M195.6-395.3v1490.5H6.5v288.8l265.8,265.9h268.5V-395.3L195.6-395.3z","4":"M1118.5-395.3l-345.2,0V6L98.4,6l-92,404L730,1649.8l388.5,0V333.3l186.6,0V6l-186.6,0V-395.3zM372,333.3l401.3,0v690.3L372,333.3z","5":"M351.4-50.2l513.8,0V553L6.5,553v1096.4l1206.3,0v-344.9l-861.3,0V908.2l595.6,0l265.7-263.3v-774.4L947-395.3l-674.9,0L6.5-129.5v283.7l345,0V-50.2z","6":"M867.8,1304.5H351.4V834.2l598.1,0l263.2-263.3v-700.3L949.5-395.3l-677.4,0L6.5-129.5v1515.7l265.7,263.1l677.4,0l263.2-265.8v-288.7l-345,0V1304.5zM351.4-50.2l516.4,0v531.6l-516.4,0V-50.2z","7":"M6.5,1304.5v344.9l1206.3,0v-344.9L747.7-395.3l-394.9,0l473.1,1699.8L6.5,1304.5z","8":"M1095.2,642.4c51.1-51.2,90.3-88.6,117.5-112.5v-659.4L949.5-395.3l-677.3,0L6.5-129.5v659.4c61.3,66.6,96.2,104,104.7,112.5L6.5,765.1v618.4l265.7,265.8l677.3,0l263.2-265.8V765.1L1095.2,642.4zM351.4,834.2l516.4,0v470.3H351.4V834.2zM351.4-50.2l516.4,0v531.6l-516.4,0V-50.2z","9":"M351.4-50.2l516.4,0v531.6l-595.6,0L6.5,744.5v639l265.7,265.8l677.3,0l263.2-263.1V-129.5L949.5-395.3l-677.3,0L6.5-129.5v283.7l345,0V-50.2zM867.8,834.2v470.3H351.4V834.2L867.8,834.2z","0":"M1202.5-131.7L939.1-395.3l-669.1,0L6.5-131.7v1500.3l263.5,263.5h671.6l261-263.5V-131.7zM860.5-53.2v1343.1h-512V-53.2L860.5-53.2z"};
// Colors are in order like this...  home: [ inside, outline, outline2, outline3 ]
var font_size = 20,
    tracking = 1.5,
    argonauts = true,
    panel_Hor_Adjustment = 1,
    font_Top_Adjustment = -6.5,
    Q_offset = {
        height: 2,
        vertical: 4
    },
    middleSplitAdjustment = -1,
    middleSpreadAdjustment = {
        left: 0.5,
        right: 0.5
    },
    small_Caps_Adjustment = {
        vertical: -50,
        horizontal: 0,
        scale_width: 0,
        scale_height: 0,
    },
    number_Adjustments = {
        top: 16,
        left: -6,
        width: 79,
        height: 60,
        spreadNumberCenterGap: 2,
        singleDigitOneOffset: 2,
        singleDigitSpread: 1.05
    },
    colors = {
        characters: {
            home: [
                "#ffffff",
            ],
            away: [
                "#0a2240",
            ],
          retro:[
                "#ffffff"
          ]
        },
        numbers: {
            home: [
                "#0a2240",
                "#ffffff",
            ],
            away: [
                "#0a2240",
                "#96c0e6",
            ],
          retro: [
                "#ffffff",
                "#7190af",
            ]
        }
    },
    outlines = {
        characters: {
            width: 0
        },
        numbers: {
            width: 1
        }
    },
    special_Character_Adjustments = {
        period: {
            vertical: -4.5, // this moves it up from the bottom
            horizontal: 3,
            scale_width: 12.5,
            scale_height: 12.5,
        },
        hyphen: {
            vertical: -6,
            horizontal: -5.5,
            scale_width: 0,
            scale_height: -3,
        },
        apostrophe: {
            vertical: 0.25, // this is backwards
            horizontal: -1,
            scale_width: 0,
            scale_height: 0,
        }
    };
